import { twMerge } from 'tailwind-merge';

/**
 * Assemble des classes Tailwind en laissant la DERNIÈRE gagner quand deux
 * touchent la même propriété.
 *
 * Avant, cette fonction se contentait de coller les classes bout à bout. Les
 * deux se retrouvaient alors dans le HTML et c'était l'ordre de la feuille
 * générée qui tranchait, pas l'ordre d'écriture : un `<Button className="text-base">`
 * gardait le `text-sm` de sa taille par défaut, un `className="px-2"` gardait le
 * `px-4` de sa variante. Le correctif écrit depuis l'appelant était silencieusement
 * inerte — invisible à la relecture, et découvert seulement à l'écran.
 *
 * twMerge résout ces conflits : la dernière classe gagne, comme on s'y attend.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return twMerge(parts.filter(Boolean).join(' '));
}
